module.exports = __webpack_public_path__ + "media/recipes/109-ef880d5a.png";